module.exports = __webpack_public_path__ + "static/media/shieldStandart.2477b65b.jpg";